declare global {
  interface Window {
    zaraz?: {
      track: (eventName: string, properties?: Record<string, string>) => void;
    };
  }
}

export function track(eventName: string, properties?: Record<string, string>) {
  window.zaraz?.track(eventName, properties);
}
